import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as css from './reg-item-form.scss'
import ImageUploadPreviewer from 'shared/image-upload-previewer/image-upload-previewer'
import { Input } from 'components/forms'
import FavoriteToggle from 'shared/reg-item-form/components/favorite-toggle'
import CategorySelector from './category-selector'
import classNames from 'classnames'
import Quantity from 'components/quantity'

export default class FavorFields extends Component {
  static propTypes = {
    categories: PropTypes.array,
    regItem: PropTypes.object,
    onRegItemChange: PropTypes.func.isRequired,
    onNewCategoryChange: PropTypes.func.isRequired,
  }

  onImageChange = ({ imgUrl }) => {
    this.props.onRegItemChange({ imgUrl })
  }
  handleChange = (e) => {
    this.props.onRegItemChange({ [e.target.name]: e.target.value })
  }
  onFavoriteChange = (isChecked) => {
    this.props.onRegItemChange({ isFavorite: isChecked })
  }

  handleQuantityChange = (value) => {
    this.props.onRegItemChange({ quantity: value })
  }

  render() {
    const regItemFields = this.props.regItem

    return (
      <React.Fragment>
        <div className={css.item}>
          <div className={classNames(css.imageContainer, 'mtm')}>
            <ImageUploadPreviewer
              imgUrl={regItemFields.imgUrl}
              onChange={this.onImageChange}
            />
          </div>

          <div className={css.itemFields}>
            <Input
              label="Title"
              value={regItemFields.title}
              onChange={this.handleChange}
              name="title"
              error={regItemFields.title ? null : 'Title cannot be blank'}
            />

            <div className="inline-form mbl">
              <Quantity
                className={css.flexGrow}
                value={regItemFields.quantity}
                onChange={this.handleQuantityChange}
                unlimited={true}
              />
            </div>

            <div className="inline-form">
              <CategorySelector
                groupClassName={css.flexGrow}
                name="categoryId"
                value={regItemFields.categoryId}
                categories={this.props.categories}
                onCategoryChange={this.props.onRegItemChange}
                onCategoryAdd={this.props.onNewCategoryChange}
              />
              <FavoriteToggle
                className={css.flexGrow}
                defaultOn={this.props.regItem.isFavorite}
                onClick={this.onFavoriteChange}
              />
            </div>
          </div>
        </div>

        <Input
          label="Url"
          value={regItemFields.url}
          onChange={this.handleChange}
          name="url"
          groupClassName="mbl"
          error={regItemFields.url ? null : 'Url cannot be blank'}
        />

        <Input
          label="Notes for friends and family"
          type="textarea"
          onChange={this.handleChange}
          name="description"
          value={regItemFields.description || ''}
          className={css.notes}
          placeholder="Let your Gift Givers know how they can help!"
        />
      </React.Fragment>
    )
  }
}
